import { Reducer } from 'redux';
import { getType } from '@anm/helpers/saga/typesafe-actions';

import { deleteAccountAsync } from '../actions';
import { UserActions } from '../types';

import { initialUserState } from '.';

const deleteAccountReducer: Reducer<typeof initialUserState, UserActions> = (
  state = initialUserState,
  action
) => {
  switch (action.type) {
    case getType(deleteAccountAsync.request): {
      return {
        ...state,
        deleteAccount: {
          isError: false,
          isDeleted: false,
          isPending: true
        }
      };
    }
    case getType(deleteAccountAsync.success): {
      return {
        ...state,
        deleteAccount: {
          isError: false,
          isDeleted: true,
          isPending: false
        }
      };
    }
    case getType(deleteAccountAsync.failure): {
      const error = action.payload;

      return {
        ...state,
        deleteAccount: {
          error,
          isError: true,
          isDeleted: false,
          isPending: false
        }
      };
    }
    default:
      return state;
  }
};

export default deleteAccountReducer;
